import NavigationError from "@/errors/navigation-error";

import { FC, PropsWithChildren, useEffect } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { Outlet, useNavigate } from "react-router";
import Loader from "./loader";

const Fallback: FC<PropsWithChildren<FallbackProps>> = ({
  error,
  resetErrorBoundary,
  children,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (error instanceof NavigationError) {
      navigate(error.navigateTo, { replace: true });
      resetErrorBoundary();
    }
  }, [error, navigate, resetErrorBoundary]);

  if (!(error instanceof NavigationError)) {
    return children ?? <Outlet />;
  }

  return <Loader />;
};

const NavigationErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      {children ?? <Outlet />}
    </ErrorBoundary>
  );
};

export default NavigationErrorBoundary;
